import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthFacade } from '@lyceo/shared/auth/data-access';
import { IonContent, IonButton } from '@ionic/angular/standalone';

@Component({
  selector: 'app-no-access-page',
  templateUrl: './no-access-page.component.html',
  styleUrls: ['./no-access-page.component.scss'],
  imports: [IonContent, IonButton],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoAccessPageComponent {
  private readonly authFacade: AuthFacade = inject(AuthFacade);

  public logout(): void {
    this.authFacade.userLogout();
  }
}
